import { FieldType } from "@entaconsulting/form";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import AddchartIcon from "@mui/icons-material/Addchart";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import TagIcon from "@mui/icons-material/Tag";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import React from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import AddDateFieldIcon from "../components/EditorDrawer/icons/AddDateFieldIcon";
import AddFieldIcon from "../components/EditorDrawer/icons/AddFieldIcon";
import AddLayoutIcon from "../components/EditorDrawer/icons/AddLayoutIcon";
import AddOptionsFieldIcon from "../components/EditorDrawer/icons/AddOptionsFieldIcon";
import AddTextFieldIcon from "../components/EditorDrawer/icons/AddTextFieldIcon";
import AddTextIcon from "../components/EditorDrawer/icons/AddTextIcon";
import {
  ToolbarActionMode,
  onChangeFieldTypeIdMode,
  toggleModeEditor,
} from "../store/toolbar";

type CommonMenuOptions = {
  id: number;
  label: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  selected?: boolean;
  expanded?: boolean;
  onClick?: (e: any) => void;
};

export type LayoutMenuOption = CommonMenuOptions & {
  mode: ToolbarActionMode;
  items?: FieldTypeOption[];
};

export type FieldTypeOption = CommonMenuOptions & {
  value: FieldType;
};

export const FIELD_TYPE_OPTIONS: FieldTypeOption[] = [
  { id: 1, label: "Text", value: "text", icon: <AddTextFieldIcon /> },
  { id: 2, label: "Number", value: "number", icon: <TagIcon /> },
  { id: 3, label: "Date", value: "date", icon: <AddDateFieldIcon /> },
  {
    id: 4,
    label: "DateTime",
    value: "datetime",
    icon: <ScheduleOutlinedIcon />,
  },
  { id: 5, label: "URL", value: "url", icon: <InsertLinkOutlinedIcon /> },
  {
    id: 6,
    label: "Email",
    value: "email",
    icon: <EmailOutlinedIcon />,
  },
  {
    id: 7,
    label: "Options",
    value: "options",
    icon: <AddOptionsFieldIcon />,
  },
  {
    id: 8,
    label: "Boolean",
    value: "boolean",
    icon: <ToggleOffOutlinedIcon />,
  },
  {
    id: 9,
    label: "Tristate",
    value: "tristate",
    icon: <IndeterminateCheckBoxOutlinedIcon />,
  },
  {
    id: 10,
    label: "Attachment",
    value: "attachment",
    icon: <AttachFileOutlinedIcon />,
  },
];

const LAYOUT_OPTIONS: LayoutMenuOption[] = [
  {
    id: 1,
    label: "Field",
    icon: <AddFieldIcon />,
    mode: "insert-field",
    expanded: true,
    items: FIELD_TYPE_OPTIONS,
  },
  { id: 2, label: "Text", mode: "insert-text", icon: <AddTextIcon /> },
  {
    id: 3,
    label: "Image",
    mode: "insert-image",
    icon: <AddPhotoAlternateOutlinedIcon />,
  },
  {
    id: 4,
    label: "Layout",
    mode: "insert-layout",
    icon: <AddLayoutIcon />,
  },
  {
    id: 5,
    label: "Table",
    mode: "insert-table",
    icon: <AddchartIcon />,
  },
];

const useInsertionMenuOptions = () => {
  const dispatch = useAppDispatch();

  const { editorMode } = useAppSelector(
    (state) => state.developer.edit.toolbar
  );

  const handleClickLayoutOption = (mode: ToolbarActionMode) => (e: any) => {
    if (mode === "insert-field") return;
    dispatch(toggleModeEditor(mode));
  };

  const handleClickFieldOption = (id: number) => (e: any) => {
    dispatch(onChangeFieldTypeIdMode(id));
  };

  return LAYOUT_OPTIONS.map((option) => ({
    ...option,
    onClick: handleClickLayoutOption(option.mode),
    selected: editorMode.mode === option.mode,
    items: option.items?.map((item) => ({
      ...item,
      selected:
        editorMode.fieldTypeIdMode === item.id &&
        editorMode.mode === "insert-field",
      onClick: handleClickFieldOption(item.id),
    })),
  }));
};

export default useInsertionMenuOptions;
